<template>
  <b-col md="12">
    <p class="text-dark font-size-h5 font-weight-bold">Thông tin điều hàng</p>

    <b-row class="mb-4">
      <b-col md="6">
        <span class="font-weight-bold mr-2">Cửa hàng đích (kho nhận hàng):</span>
        <strong>{{ sourceStoreLabel }}</strong>
      </b-col>
      <b-col md="6">
        <span class="font-weight-bold mr-2">Cửa hàng nguồn (kho gửi hàng):</span>
        <span
          v-for="(s, i) in destinationStores"
          :key="i"
          class="badge badge-secondary mr-1"
        >
          {{ s }}
        </span>
      </b-col>
    </b-row>

    <div v-if="products.length" class="mb-4">
      <p class="font-weight-bold mb-2">Sản phẩm yêu cầu điều</p>
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>Sản phẩm</th>
            <th style="width: 140px" class="text-center">Số lượng</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(p, i) in products" :key="i">
            <td>{{ p.productName || p.productId }}</td>
            <td class="text-center">{{ p.quantity }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Hoàn thành: liên kết phiếu chuyển kho -->
    <b-alert
      v-if="ticket.status === TICKET_STATUS.COMPLETED && ticket.stockSlipId"
      show
      variant="success"
    >
      Phiếu chuyển kho liên quan:
      <strong>#{{ ticket.stockSlipId }}</strong>
    </b-alert>

    <!-- Từ chối: lý do -->
    <b-alert
      v-if="ticket.status === TICKET_STATUS.REJECT"
      show
      variant="danger"
    >
      <div>
        <span class="font-weight-bold">Lý do từ chối:</span>
        {{ rejectReasonName }}
      </div>
      <div v-if="ticket.orderId">
        <span class="font-weight-bold">Mã đơn hàng ID:</span>
        {{ ticket.orderId }}
      </div>
      <div v-if="ticket.reason">
        <span class="font-weight-bold">Ghi chú:</span> {{ ticket.reason }}
      </div>
    </b-alert>
  </b-col>
</template>

<script>
import { TICKET_STATUS } from '@/utils/enum';
import { STOCK_TRANSFER_REJECT_REASON_NAME } from '@/utils/enum-name';

export default {
  props: ['ticket'],
  data() {
    return {
      TICKET_STATUS,
    };
  },
  computed: {
    products() {
      return this.ticket && this.ticket.TicketProducts
        ? this.ticket.TicketProducts
        : [];
    },
    destinationStores() {
      const list =
        this.ticket && this.ticket.TicketStores ? this.ticket.TicketStores : [];
      return list.map((s) => (s.Store && s.Store.name ? s.Store.name : `#${s.storeId}`));
    },
    sourceStoreLabel() {
      return this.ticket && this.ticket.sourceStoreId
        ? `#${this.ticket.sourceStoreId}`
        : '--';
    },
    rejectReasonName() {
      const type = this.ticket ? this.ticket.rejectReasonType : null;
      return STOCK_TRANSFER_REJECT_REASON_NAME[type] || type || '--';
    },
  },
};
</script>
